import { CButton, CRow } from '@coreui/react-pro';
import { useMutation } from '@tanstack/react-query';
import _ from 'lodash';
import React, { useEffect, useRef, useState } from 'react';
import OtpInput from 'react-otp-input';
import { useLocation, useNavigate } from 'react-router-dom';
import { AdminOtpVerificationAPI, AdminResendOTP } from '../../../api/auth.api';
import UseToast from '../../../hooks/useToast';
import './index.scss';
import { useTypedSelector, useTypesDispatch } from '../../../redux/hooks';
import {
  setUserDetails,
  signedInUserDetailsState,
} from '../../../redux/slice/SignedInUserDetailsSlice';
import { customerOTP, customerSignIn } from '../../../api/customerPortal.api';
import Loader from '../../../components/loader';
import { SajlhaSignInAPI } from '../../../api/oauth.api';
import env from '../../../env';

// forward ref 

const OtpScreen = React.forwardRef<any, any>(({
  contactNumber,
  countryPrefix,
  password,
  sendOtp: mutate,
  isLoading,
  setOTP,
  otp,
  code
}, ref: any) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useTypesDispatch();
  const { userDetails } = useTypedSelector(signedInUserDetailsState);

 
  const [seconds, setSeconds] = useState<number>(30);
  const [resendOtpEnable, setresendOtpEnable] = useState<boolean>(true);
  const [attempt, setAttempts] = useState(0);

  useEffect(() => {
    if (seconds > 0) {
      startTimer();
    }
  }, [seconds]);

  const delay = (ms: number) => new Promise((res) => setTimeout(res, ms));

  const startTimer = async () => {
    await delay(1000);
    setSeconds(seconds - 1);
    if (seconds - 1 === 0) {
      setresendOtpEnable(false);
    }
  };

  const { mutate: resendOTPMutate } = useMutation(SajlhaSignInAPI, {
    onSuccess: (data) => {
      UseToast('Verification code has been sent - تم إرسال رمز التحقق', 'success');

      setresendOtpEnable(true);
      setSeconds(30);
      setAttempts(attempt + 1);
    },
  });

  const handleOtpVerification = async (otp: string) => {
    mutate({
      contactNumber,
      countryPrefix,
      deviceType: 'ANDROID',
      language: 'en',
      otp,
      password,
      isProvider: true,
      code:code
    });
  };

  const resenClicked = () => {
    setSeconds(30);
    resendOTPMutate({
      contactNumber: contactNumber,
      countryPrefix: countryPrefix,
      password: password,
      isProvider: true,
      
    });
  };

  // new added
  const handleChange = (e: any) => {
    const { maxLength, value, name } = e.target;
    const [fieldName, fieldIndex] = name.split('-');

    const fieldIntIndex = parseInt(fieldIndex, 10);

    if (!value) {
      const newOtp = [...otp];
      newOtp[fieldIndex - 1] = value;
      setOTP(newOtp);
    }

    // Check if no of char in field == maxlength
    if (value.length >= maxLength) {
      // It should not be last input field
      if (fieldIntIndex <= 4) {
        // Get the next input field using it's name
        const newOtp = [...otp];
        newOtp[fieldIndex - 1] = value;
        setOTP(newOtp);
        const nextfield = document.querySelector(`input[name=field-${fieldIntIndex + 1}]`);

        const isOtpEmpty = newOtp.join('').length < 4;
        // If found, focus the next field
        if (nextfield !== null && !newOtp[fieldIndex]) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          nextfield.focus();
        } else if (!isOtpEmpty) {
          handleOtpVerification(newOtp.join(''));
        }
      }
    }
  };
  return (
    <div className="otp-container" style={{ flexGrow: 1, minHeight: '70vh' }}>
      <div>
        <h1 style={{ color: '#F7C72E' }} className="text-center">
          Mobile Verification | رمز التحقق
        </h1>
        <p style={{ color: '#fff' }} className="mt-5">
          Please enter the verification code received on your mobile phone.
        </p>
        <p style={{ color: '#fff' }} className="text-right">
          {' '}
          الرجاء إدخال رمز التحقق المستلم على هاتفك المحمول
        </p>
      </div>
      <div className="mainOtp">
        <input
          ref={(input) => (ref.current = input)}
          name="field-1"
          maxLength={1}
          inputMode="numeric"
          className="otp-input-screen"
          type="number"
          onChange={handleChange}
          value={otp[0]}
          onPaste={(e: any) => {
            e.preventDefault();
            return false;
          }}
          autoFocus
        />
        <span>-</span>
        <input
          name="field-2"
          inputMode="numeric"
          maxLength={1}
          className="otp-input-screen"
          type="number"
          onChange={handleChange}
          value={otp[1]}
          onPaste={(e: any) => {
            e.preventDefault();
            return false;
          }}
        />
        <span>-</span>
        <input
          name="field-3"
          inputMode="numeric"
          maxLength={1}
          className="otp-input-screen"
          type="number"
          onChange={handleChange}
          value={otp[2]}
          onPaste={(e: any) => {
            e.preventDefault();
            return false;
          }}
        />
        <span>-</span>
        <input
          name="field-4"
          inputMode="numeric"
          maxLength={1}
          className="otp-input-screen"
          type="number"
          onChange={handleChange}
          value={otp[3]}
          onPaste={(e: any) => {
            e.preventDefault();
            return false;
          }}
        />
      </div>
      {isLoading ? <Loader /> : null}
      {attempt < 4 ? (
        <CRow>
          <div className="d-flex" style={{ alignItems: 'center' }}>
            <CButton
              color="link"
              onClick={resenClicked}
              disabled={resendOtpEnable}
              className="px-0 mt-3 ml5"
            >
              Did not Receive a code ? Resend | إعادة إرسال
            </CButton>
            {seconds !== 0 && (
              <div className="px-0 mt-3 ml5">
                - 00: {seconds > 9 ? '' : 0}
                {seconds}
              </div>
            )}
          </div>
        </CRow>
      ) : (
        <p className="mt-5">Please try to sign in again</p>
      )}
    </div>
  );
});

export default OtpScreen;
